import { actions } from './actions'

const initialState = {
  estadosUsuarios: {
    data: [],
    loading: false,
    error: '',
  },
  estadoUsuario: {
    data: null,
    loading: false,
    error: '',
  },
}

export default function estadosUsuariosReducer(state = initialState, action) {
  switch (action.type) {
    case actions.ESTADOS_USUARIOS_LOAD_REQUESTED:
      return { ...state, estadosUsuarios: { ...state.estadosUsuarios, loading: true } }
    case actions.ESTADOS_USUARIOS_LOAD_SUCCEEDED:
      return {
        ...state,
        estadosUsuarios: { ...state.estadosUsuarios, data: action.payload, loading: false },
      }
    case actions.ESTADOS_USUARIOS_LOAD_FILED:
      return {
        ...state,
        estadosUsuarios: { ...state.estadosUsuarios, loading: false, error: action.error },
      }
    case actions.ESTADOS_USUARIOS_UPDATE_REQUESTED:
      return {
        ...state,
        estadosUsuarios: { ...state.estadosUsuarios, loading: true, error: '' },
      }
    case actions.ESTADOS_USUARIOS_UPDATE_SUCCEEDED:
      return {
        ...state,
        estadosUsuarios: {
          ...state.estadosUsuarios,
          data: state.estadosUsuarios.data.map(estadoUsuario =>
            estadoUsuario.id === action.payload.id ? action.payload : estadoUsuario,
          ),
          loading: false,
          error: '',
        },
      }
    case actions.ESTADOS_USUARIOS_UPDATE_FILED:
      return {
        ...state,
        estadosUsuarios: { ...state.estadosUsuarios, loading: false, error: action.error },
      }
    case actions.ESTADOS_USUARIOS_INSERT_REQUESTED:
      return {
        ...state,
        estadosUsuarios: { ...state.estadosUsuarios, loading: true, error: '' },
      }
    case actions.ESTADOS_USUARIOS_INSERT_SUCCEEDED:
      return {
        ...state,
        estadosUsuarios: {
          ...state.estadosUsuarios,
          data: [].concat(action.payload, state.estadosUsuarios.data),
          loading: false,
          error: '',
        },
      }
    case actions.ESTADOS_USUARIOS_INSERT_FILED:
      return {
        ...state,
        estadosUsuarios: { ...state.estadosUsuarios, loading: false, error: action.error },
      }
    case actions.ESTADOS_USUARIOS_DELETE_REQUESTED:
      return {
        ...state,
        estadosUsuarios: { ...state.estadosUsuarios, loading: true, error: '' },
      }
    case actions.ESTADOS_USUARIOS_DELETE_SUCCEEDED:
      return {
        ...state,
        estadosUsuarios: {
          ...state.estadosUsuarios,
          data: state.estadosUsuarios.data.filter(
            estadoUsuario => estadoUsuario.id !== action.payload,
          ),
          loading: false,
          error: '',
        },
      }
    case actions.ESTADOS_USUARIOS_DELETE_FILED:
      return {
        ...state,
        estadosUsuarios: { ...state.estadosUsuarios, loading: false, error: action.error },
      }
    case actions.ESTADOS_USUARIOS_LOAD_BY_ID_REQUESTED:
      return { ...state, estadoUsuario: { ...state.estadoUsuario, loading: true } }
    case actions.ESTADOS_USUARIOS_LOAD_BY_ID_SUCCEEDED:
      return {
        ...state,
        estadoUsuario: { ...state.estadoUsuario, data: action.payload, loading: false },
      }
    case actions.ESTADOS_USUARIOS_LOAD_BY_ID_FILED:
      return {
        ...state,
        estadoUsuario: { ...state.estadoUsuario, loading: false, error: action.error },
      }
    default:
      return state
  }
}
